export default __webpack_public_path__ + "static/quoteimg-6845b4bc98d9dded2488d19fcc6c3ee8.svg";